// extracted by mini-css-extract-plugin
export default {"item":"friendListItem_item__iGDyE","status_on":"friendListItem_status_on__g-8lc","status_off":"friendListItem_status_off__3oKjy"};